module.exports = __webpack_public_path__ + "static/media/down-arrow.12ac6cf4.png";